import React from 'react'

function EUR({ className, size }) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={size ?? 32}
      height={size ?? 32}
      fill='none'
      viewBox='0 0 32 32'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z'
        fill='#00B26B'
      />
      <path
        d='M20.1825 13.3222H13.6464C14.2624 10.9867 15.751 9.85741 17.6673 9.85741C19.1644 9.85741 20.3194 10.5589 21.1407 11.2091L22.3384 8.6597C21.0722 7.59886 19.4981 7 17.6673 7C14.0314 7 11.2852 9.327 10.4468 13.3222H8.67586L8 15.1445H10.2072C10.1901 15.4268 10.1816 15.7177 10.1816 16.0171C10.1816 16.2994 10.1901 16.5817 10.2072 16.8555H8.67586L8 18.7034H10.4468C11.2852 22.6901 14.0314 25 17.6673 25C19.4297 25 21.0637 24.461 22.2871 23.4002L21.0722 20.8508C20.3279 21.4496 19.173 22.1426 17.6673 22.1426C15.7424 22.1426 14.2624 21.039 13.6464 18.7034H17.7186L18.5998 16.8555H13.3641C13.347 16.5903 13.3384 16.308 13.3384 16.0171C13.3384 15.7177 13.347 15.4268 13.3641 15.1445H19.3527L20.1825 13.3222Z'
        fill='white'
      />
    </svg>
  )
}

export default EUR
